import type { IconSvgObject } from './types';

const CarouselHorizontal02Icon: IconSvgObject = [
  ["path", { d: "M16 4H8C6.89543 4 6 4.89543 6 6V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V6C18 4.89543 17.1046 4 16 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 6.5C21.1716 6.5 20.5 7.17157 20.5 8V16C20.5 16.8284 21.1716 17.5 22 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 6.5C2.82843 6.5 3.5 7.17157 3.5 8V16C3.5 16.8284 2.82843 17.5 2 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CarouselHorizontal02Icon;
